import React from 'react';
import { ProfileContent } from './common';

const Premium = ({ profile, currentProfile, onCreate }) => {
  return (
    <>
      <ProfileContent
        profile={profile}
        currentProfile={currentProfile}
        onCreate={onCreate}
      />
    </>
  );
};

export { Premium };
